import { render, staticRenderFns } from "./popup_call.vue?vue&type=template&id=00bc7c07"
import script from "./popup_call.vue?vue&type=script&lang=js"
export * from "./popup_call.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports